import { render } from "./CourseDetails.vue?vue&type=template&id=1f19d94a&scoped=true"
import script from "./CourseDetails.vue?vue&type=script&lang=js"
export * from "./CourseDetails.vue?vue&type=script&lang=js"

import "./CourseDetails.vue?vue&type=style&index=0&id=1f19d94a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vue-soft/vue-soft/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f19d94a"]])

export default __exports__